var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F9C9BF83-A838-4FDA-A773-F1343EF6ADE7@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Icons/System/Arrows/Left"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) ",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.889,10.939 L7.646,15.182 C7.25553468,15.5724653 6.62246532,15.5724653 6.232,15.182 C5.84153468,14.7915347 5.84153468,14.1584653 6.232,13.768 L11.1818932,8.81810678 C11.5724175,8.42758249 12.2055825,8.42758249 12.5961068,8.81810678 L17.546,13.768 C17.9364653,14.1584653 17.9364653,14.7915347 17.546,15.182 C17.1555347,15.5724653 16.5224653,15.5724653 16.132,15.182 L11.889,10.939 L11.889,10.939 Z",
    id: "Path",
    fill: "currentColor",
    transform: "translate(11.889000, 12.000000) rotate(-90.000000) translate(-11.889000, -12.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeft);
export default __webpack_public_path__ + "static/media/icon_arrow_left.1c1d4d9b154166ae0d23d4ce876d3764.svg";
export { ForwardRef as ReactComponent };